// extracted by mini-css-extract-plugin
export var addToCartButton = "_tl-b";
export var arrowButtonContainer = "_tl-9";
export var arrowButtonIcon = "_tl-a";
export var carouselArrowButton = "_tl-6";
export var carouselElementContainer = "_tl-1";
export var left = "_tl-7";
export var productDisplayCarouselContainer = "_tl-0";
export var productTileContainer = "_tl-2";
export var productTileImage = "_tl-4";
export var productTileImageContainer = "_tl-3";
export var productTileTitle = "_tl-5";
export var right = "_tl-8";
export var sliderOverflow = "_tl-c";